import React from 'react';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { SeeMoreButton } from 'src/ui/components/collapse/sports/05/Collapse.style';
import { SectionHeader, SectionHeaderPropsType } from 'src/ui/components/collapse/sports/05/SectionHeader';

interface SectionHeaderSeeMorePropsType extends SectionHeaderPropsType {
    onClick?: () => void;
    isSeeMoreVisible?: boolean;
}

export const SectionHeaderSeeMore = ({
    title,
    dataTest,
    onClick,
    isSeeMoreVisible = true,
}: SectionHeaderSeeMorePropsType) => {
    return (
        <SectionHeader
            title={
                <>
                    {title}
                    {isSeeMoreVisible && (
                        <SeeMoreButton
                            size='small'
                            appearance='secondary'
                            variant={DefaultComponentVariantType.TERTIARY}
                            onClick={onClick}
                        >
                            <I18n
                                langKey='section-header.see-more'
                                defaultText='See More'
                            />
                        </SeeMoreButton>
                    )}
                </>
            }
            dataTest={dataTest}
        />
    );
};
